/**
* Allowed countries by age for alcohol consomation in both English and french.
*/
var en_legal 	= ['Albania','Angola','Armenia','Cambodia','Comoros','Cuba','Equatorial Guinea','Ghana','Guinea-Bissau','Jamaica','Macedonia, the former Yugoslav Republic of','Montenegro','Morocco','Norway','Romania','Swaziland','Togo','Uruguay','Viet Nam'],
	en_legal_16 = ['Austria','Belgium','Bosnia and Herzegovina','Germany','Georgia','Haiti','Italy','Liechtenstein','Luxembourg','Macao','Malaysia','Netherlands','Sudan','Switzerland','Tokelau'],
	en_legal_17 = ['Cyprus','Malta'],
	en_legal_18 = ['Algeria','Argentina','Australia','Azerbaijan','Bahamas','Belarus','Belize','Bermuda','Bolivia','Botswana','Brazil','Burundi','Cameroon','Canada','Cape Verde','Central African Republic','Chile','China','District of Columbia','Costa Rica','Croatia','Czech Republic','Denmark','Dominican Republic','Ecuador','Egypt','Eritrea','Estonia','Ethiopia','Fiji','Finland','France','Gabon','Gambia','Gibraltar','Greece','Guatemala','Guyana','Honduras','Hong Kong','Hungary','India','Iraq','Ireland','Israel','Jordan','Kenya','Lebanon','Lithuania','Malawi','Maldives','Mauritius','Mexico','Moldovia','Mongolia','Mozambique','Namibia','Nepal','New Zealand','Niger','Nigeria','Korea, Democratic People\'s Republic of','Panama','Papua New Guinea','Peru','Philippines','Puerto Rico','Poland','Portugal','China','Congo','Russia','Rwanda','Samoa','Serbia','Seychelles','Singapore','Slovakia','Slovena','South Africa','Spain','Sweden','Syria','Tanzania','Thailand','Tonga','Trinidad and Tobago','Tunisia','Turkey','Turkmenistan','Uganda','Ukraine','United Kingdom','Virgin Islands, U.S.','Vanuatu','Venezuela','Zambia','Zimbabwe'],
	en_legal_19 = ['Nicaragua','Korea, Republic of'],
	en_legal_20 = ['Iceland','Japan','Paraguay'],
	en_legal_21 = ['Indonesia','Kazakhstan','Oman','Pakistan','Palau','Sri Lanka','United States'];

var fr_legal 	= ['Albanie','Angola','Armenie','Cambodge','Comores (pays)','Cuba','Guinée équatoriale','Ghana','Guinea-Bissau','Jamaïque','Macédoine','Monténégro','Maroc','Norvège','Roumanie','Swaziland','Togo','Uruguay','Viet Nam'],
	fr_legal_16 = ['Autriche','Belgique','Bosnie-Herzégovine','Alemagne','Georgie','Haïti','Italie','Liechtenstein','Luxembourg','Macao','Malaisie','Pays-Bas','Soudan','Suisse','Tokelau'],
	fr_legal_17 = ['Chypre','Malte'],
	fr_legal_18 = ['Algérie','Argentine','Australie','Azerbaijan','Bahamas','Biélorussie','Belize','Bermudes','Bolivie','Botswana','Brézil','Burundi','Cameroun','Canada','Cap-Vert','République centrafricaine','Chili','Chine','District de Columbia','Costa Rica','Croatie','République tchèque','Danemark','République dominicaine','Équateur','Égypte','Érythrée','Estonie','Ethiopie','Fidji','Finlande','France','Gabon','Gambie','Gibraltar','Grèce','Guatemala','Guyane','Honduras','Hong Kong','Hongrie','Inde','Irak','Irelande','Israël','Jordanie','Kenya','Liban','Lithuanie','Malawi','Maldives','Maurice','Mexique','Moldovie','Mongolie','Mozambique','Namibie','Nepal','Nouvelle-Zélande','Niger','Nigeria','Corée du Nord','Panama','Papouasie-Nouvelle-Guinée','Perou','Philippines','Puerto Rico','Pologne','Portugal','Chine','République du Congo','Russie','Rwanda','Samoa','Serbie','Seychelles','Singapour','Slovaquie','Slovénie','Afrique du Sud','Espagne','Suède','Syrie','Tanzanie','Thaïlande','Tonga','Trinité-et-Tobago','Tunisie','Turquie','Turkménistan','Uganda','Ukraine','Royaume-Uni','Îles Vierges des États-Unis','Vanuatu','Venezuela','Zambie','Zimbabwe'],
	fr_legal_19 = ['Nicaragua','Corée du Sud'],
	fr_legal_20 = ['Islande','Japon','Paraguay'],
	fr_legal_21 = ['Indonésie','Kazakhstan','Oman','Pakistan','Palau','Sri Lanka','États-Unis'];


jQuery(".production_text_container").height(jQuery(".production-content").outerHeight());

jQuery( window ).resize(function() {
  jQuery(".production_text_container").height(jQuery(".production-content").outerHeight());
});

jQuery('[data-reveal]').on('open.zf.reveal', function() {

});

jQuery( "body" ).on( "click",".menu-mobile", function() {
  jQuery('#ModalMenu').toggleClass("hide-mobile-menu");
});
jQuery( "body" ).on( "click",".menu-mobile-container a", function() {
  jQuery('#ModalMenu').toggleClass("hide-mobile-menu");
});


if(jQuery.cookie('age') != "true"){
  jQuery('#age').foundation('open');

  jQuery('body').on('change',"#age input, #age select",function(){

    /* NEW VERSION
      choix de la langue.
      choisir le pays.
      affiche age légal du pays (numéro).
      case cocher.
      bouton de validation.
    */
    var countries = [],
    country = jQuery('#age .country select').val(),
    language = jQuery.cookie('pll_language'),
    age = 16,
    checked = 0,
    lang = jQuery('#age .language select').val();

    for (var i = 16; i <= 21; i++) {
      var countries = window[language+'_legal_'+i];
      if (jQuery.inArray(country, countries) != -1) {
        age = i;
        break;
      } else {
        age = 16;
      }
    }
    if (lang == 'fr') {
      jQuery('#age-validation span').text('Je certifie avoir au moins '+ age +' ans afin d’accéder à ce site.')
    } else if (lang == 'en') {
      jQuery('#age-validation span').text('I hereby certify that I am at least '+ age +' years old to access this website')
    }

  });

}

jQuery( "body" ).on( "click","#age-verification", function() {
  if (jQuery('.age_tcheck').is(':checked')) {
        jQuery('#age').foundation('close');
        jQuery.cookie("age", "true");
    }
});
